export default "__VITE_ASSET__D0M0ZRVn__"